import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { InvitationEntity } from "../../../../../entities/ServicesEntities/UserEntities/InvitationEntity";
import { ADD_PARKER_FORM_STEPS } from "../../../../../enums/Enums";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import Icons from "../../../../../resources/icons/Icons";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { getSiteByScopeId } from "../../../../../utils/UsersUtils";
import { MessageEntity } from "../../../../../entities/UIEntities/MessageEntity";
import {
  closeMessageModal,
  showErrorMessage,
  showInviteSuccessMessage
} from "../../../../../utils/MessagesUtils";
import { phoneNumberToSend } from "../../../../../utils/CommonUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import InviteNewGmtUserStep from "../Steps/InviteNewGmtUserStep";
import classes from "../WizardForm.module.css";

const InviteNewGmtUserForm = () => {
  const currentGmtUser = useSelector((state) => state.user.gmtUser);
  const currentUsersScopes = useSelector((state) => state.user.currentUsersScopes); // added
  const sites = useSelector((state) => state.user?.sites); // added
  const [sitesData, setSitesData] = useState([]); // added
  // const allGmtUsersData = useSelector((state) => state.user.currentGmtUsers);
  // const userData = allGmtUsersData?.find(
  //   (gmtUser) => gmtUser?.id === currentGmtUser?.userIdentity?.id
  // );

  const [formData, setFormData] = useState({
    email: "",
    dialingCode: DEFAULT_DIALING_CODE,
    phoneNumber: "",
    /*userScopes: userData?.userScopes,*/
    scopesList: currentUsersScopes, // userData?.userSitesByScopes
    role: "",
    scope:
    currentUsersScopes?.length > 0
        ? currentUsersScopes[0].id
        : "",
    site: currentUsersScopes?.length > 0
    ? currentUsersScopes[0]
    : {},
  });

  // added - check for every scope its sites to show for select input
  useEffect(() => {
    let sitesDataToUpdate = [];
    currentUsersScopes.forEach((userScope) => {
      let siteData = getSiteByScopeId(sites, userScope.id);
      if (siteData) {
        sitesDataToUpdate.push(siteData);
      }
    });
    setSitesData(sitesDataToUpdate);

  }, [currentUsersScopes]);

  // before
  // const [formData, setFormData] = useState({
  //   email: "",
  //   phoneNumber: "",
  //   userScopes: userData?.userScopes,
  //   sitesList: userData?.userSitesByScopes, // userData?.userSitesByScopes
  //   role: "",
  //   site:
  //     userData?.userSitesByScopes?.length > 0
  //       ? userData?.userSitesByScopes[0].scopeId
  //       : "",
  // });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.INVITE_NEW_GMT,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { role, site, email, dialingCode, phoneNumber } = formData;

    if (stateData.isCurrentStepValid) {
      const selectedScope = formData.scopesList.find((scope)=>scope.id === site.id); //userData?.scopes.find((scope)=>scope.id === site.id);
      const invitationEntity = new InvitationEntity(
        `${currentGmtUser?.utronUser?.firstName} ${currentGmtUser?.utronUser?.lastName}`,
        currentGmtUser?.utronUser?.identityId,
        email,
        dialingCode + phoneNumberToSend(dialingCode, phoneNumber),
        selectedScope?.id,
        role,
        selectedScope?.name
      );

      actionsService.inviteNewGmtUser(invitationEntity).then((response) => {
        if (response.data.isSuccess) {
          store.dispatch(commonActions.closeSideModal()); // close only on success
          showInviteSuccessMessage();
        } else {
          showErrorMessage(response.data?.error);
        }
      });
    }
  };

  

  return (
    <form name="InviteNewGmtUserForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div className={classes.stepContainer}>
          <div className={classes.stepTitle}>
            {Strings.STEPS_TITLES.GENERAL_DETAILS_TITLE}
          </div>
          <InviteNewGmtUserStep
            isEditMode={false}
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            sitesData={sitesData} // added
            {...formData}
          />
        </div>
        <div className={classes.next}>
          <EllipseButton type="submit">{Strings.INVITE}</EllipseButton>
        </div>
      </div>
    </form>
  );
};

export default InviteNewGmtUserForm;
